import React from 'react';
import { Box, Typography } from '@mui/material';
import { Room as RoomIcon, School as SchoolIcon } from '@mui/icons-material';
import { formatSchoolName } from '../../utils/nameFormatter';
import { isDropAPinSchool } from '../../utils/schoolDataDetection';

/**
 * Shared option rendering / filtering for school Autocomplete dropdowns.
 * Differentiates drop-a-pin locations (pin icon) from regular schools (school icon),
 * matching the AI School Summary tool.
 */

export const getSchoolOptionLabel = (option) => (option?.name ? formatSchoolName(option.name) : '');

export const renderSchoolOption = (props, option, { dense = false } = {}) => {
  const { key, ...liProps } = props;
  const isPin = isDropAPinSchool(option);
  const location = [option.city, option.state].filter(Boolean).join(', ');

  return (
    <li {...liProps} key={option.uuid || key}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, width: '100%' }}>
        {isPin ? (
          <RoomIcon
            titleAccess="Drop-a-pin location"
            sx={{ fontSize: '1rem', color: 'warning.dark', flexShrink: 0 }}
          />
        ) : (
          <SchoolIcon
            titleAccess="School"
            sx={{ fontSize: '1rem', color: 'text.secondary', flexShrink: 0 }}
          />
        )}
        <Box>
          <Typography variant={dense ? 'body2' : 'body1'} sx={{ fontWeight: 500, lineHeight: 1.3 }}>
            {getSchoolOptionLabel(option)}
          </Typography>
          {location && (
            <Typography variant="caption" color="text.secondary">
              {location}
            </Typography>
          )}
        </Box>
      </Box>
    </li>
  );
};

/** Case-insensitive match on name, city or state. */
export const filterSchoolOptions = (options, { inputValue }) => {
  const lower = (inputValue || '').trim().toLowerCase();
  if (!lower) return options;
  return options.filter(
    (o) =>
      getSchoolOptionLabel(o).toLowerCase().includes(lower) ||
      o.city?.toLowerCase().includes(lower) ||
      o.state?.toLowerCase().includes(lower)
  );
};
